import CopyCtaBlock from "./CopyCtaBlock";

export * from "./CopyCtaBlock";
export default CopyCtaBlock;
